import axios from 'axios'

const service = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_URL || '/prod-api',
  timeout: 30000
})

// 请求拦截
service.interceptors.request.use(
  (config) => {
    // 如需 token 可在此添加
    // const token = localStorage.getItem('token')
    // if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截
service.interceptors.response.use(
  (response) => {
    const res = response.data
    // 根据后端约定的 code 判断，按需调整
    if (res.code !== undefined && res.code !== 0 && res.code !== 200) {
      console.error('[request error]', res.message || 'unknown error')
      return Promise.reject(new Error(res.message || 'request error'))
    }
    return res
  },
  (error) => {
    console.error('[request error]', error.message)
    return Promise.reject(error)
  }
)

export default service
